module.exports = __webpack_public_path__ + "static/media/watsapp_icon.81882e17.png";